import { z } from 'zod';
import { naicsCodeKindSchema, dateTimeSchema } from '../../enums.mjs';
import { naicsCodeId } from '../../types/opaque.mjs';

var Get;
(function (Get) {
    Get.responseSchema = z.object({
        id: naicsCodeId,
        code: z.string(),
        label: z.string(),
        kind: naicsCodeKindSchema,
        versionYear: z.number().int(),
        parentId: naicsCodeId.nullable(),
        deprecatedAt: dateTimeSchema.nullable(),
    });
})(Get || (Get = {}));
var List;
(function (List) {
    (function (Request) {
        Request.schema = z.object({
            versionYear: z.coerce.number().int(),
            kind: naicsCodeKindSchema.optional(),
            parentId: naicsCodeId.optional(),
        });
    })(List.Request || (List.Request = {}));
    List.responseSchema = z.array(Get.responseSchema);
})(List || (List = {}));
var Update;
(function (Update) {
    (function (Request) {
        Request.schema = z.object({
            naicsCodeIds: z.array(naicsCodeId),
        });
    })(Update.Request || (Update.Request = {}));
})(Update || (Update = {}));

export { Get, List, Update };
